import { NoChargeCampaignStep } from '~/features/campaign_create/ExpenseInfo/StepContents/NoChargeCampaignStep'
import { ExpenseCampaignStep } from './StepContents/ExpenseCampaignStep'
import { ExpenseEvidenceTypeStep } from './StepContents/ExpenseEvidenceTypeStep'
import { IntroductionStep } from '~/features/campaign_create/ExpenseInfo/StepContents/IntroductionStep'

export type StepContentRendererProps = {
  shouldHideDialog: boolean
  setShouldHideDialog: React.Dispatch<React.SetStateAction<boolean>>
}

// 配列の順番がそのままダイアログのステップの順番になっている
export const ExpenseInfoDialogSteps = [
  {
    title: '立替型と無償提供型について',
    content: () => <IntroductionStep />,
  },
  {
    title: '無償提供型について',
    content: () => <NoChargeCampaignStep />,
  },
  {
    title: '立替型について',
    content: () => <ExpenseCampaignStep />,
  },
  {
    title: '公開後にやること',
    content: (props: StepContentRendererProps) => <ExpenseEvidenceTypeStep {...props} />,
  },
] as const

export const FIRST_STEP = 0
export const LAST_STEP = ExpenseInfoDialogSteps.length - 1
export const TOTAL_STEPS = ExpenseInfoDialogSteps.length
